import React, { useEffect, useContext } from "react";
import { Footer, Header, LoginHeader } from "../../components";
import { GlobalContext } from "../../context/GlobalContext";
import "./styles.css";
import { Link } from "react-router-dom";
import { Images } from "../../theme";
import { useTranslation } from "react-i18next";

export default function Ranting() {
  const getContextItem = useContext(GlobalContext);
  let { user_data, loginData } = getContextItem;
  const { t } = useTranslation();

  useEffect(() => {
    user_data();
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {loginData?.id ? <Header /> : <LoginHeader />}
      <div className="container">
        <div className="row">
          <div className="col-12 mt-3 mb-3">
            <span className="homeHeading">{t("Home")}</span>
            <span className="arrowStyle">
              {" "}
              <img src={Images.ArrowNew} alt="image" />{" "}
            </span>
            <span className="pageHeading">{t("Renting_Works")}</span>
          </div>
        </div>
        <div className="row">
          <div className="col-12 p-0">
            <div className="blueCard">
              <h1 className="blueCardHeading">{t("Renting_1")} </h1>
              <p className="blueCardDes">{t("Renting_Description_1")}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row my-5 pt-5 lent-rent-pad">
          <div className="col-md-5 col-lg-5 m-auto spacingRightStyle">
            <p className="cartHeading">{t("Before_The_Rental")}</p>
            <div>
              <span className="lightHeading">{t("Find_An_Item")} </span>
              <span className="lightDesc">{t("Find_An_Item_Description")}</span>
            </div>
            <div>
              <span className="lightHeading">{t("Request_And_Wait")} </span>
              <span className="lightDesc">
                {t("Request_And_Wait_Description")}
              </span>
            </div>
            <div>
              <span className="lightHeading">{t("Arrange_Handover")} </span>
              <span className="lightDesc">
                {t("Arrange_Handover_Description")}
              </span>
            </div>
          </div>
          <div className="col-lg-1 d-none-tablet"></div>
          <div className="col-md-6 col-lg-6 text-center">
            <img src={Images.r1} alt="image" style={{ width: "80%" }} />
          </div>
        </div>

        <div className="row my-5 pt-5 column-reverse">
          <div className="col-md-6 col-lg-6  text-center">
            <img src={Images.r2} alt="image" style={{ width: "80%" }} />
          </div>
          <div className="col-lg-1 d-none-tablet"></div>

          <div className="col-md-5 col-lg-5 m-auto spacingLeftStyle">
            <p className="cartHeading">{t("During_The_Rental")}</p>
            <div>
              <span className="lightHeading">{t("Enjoy_Your_Rental")} </span>
              <span className="lightDesc">
                {t("Enjoy_Your_Rental_Description")}
              </span>
            </div>
            <div>
              <span className="lightHeading">{t("Take_Good_Care")} </span>
              <span className="lightDesc">
                {t("Take_Good_Care_Description")}
              </span>
            </div>
            <div>
              <span className="lightHeading">{t("Return_On_Time")} </span>
              <span className="lightDesc">
                {t("Return_On_Time_Description")}
              </span>
            </div>
          </div>
        </div>

        <div className="row my-5 pt-5">
          <div className="col-md-5 col-lg-5 m-auto spacingRightStyle">
            <p className="cartHeading">{t("After_The_Rental")}</p>
            <div>
              <span className="lightHeading">{t("Rate_The_Lender")} </span>
              <span className="lightDesc">
                {t("Rate_The_Lender_Description")}
              </span>
            </div>
            <div>
              <span className="lightHeading">{t("Repeat")} </span>
              <span className="lightDesc">{t("Repeat_Description")}</span>
            </div>
          </div>
          <div className="col-lg-1 d-none-tablet"></div>

          <div className="col-md-6 col-lg-6 text-center">
            <img src={Images.r3} alt="image" style={{ width: "80%" }} />
          </div>
        </div>

        <div className="row my-5 pt-5 column-reverse">
          <div className="col-md-6 col-lg-6 text-center">
            <img src={Images.r4} alt="image" style={{ width: "80%" }} />
          </div>
          <div className="col-lg-1 d-none-tablet"></div>

          <div className="col-md-5 col-lg-5 m-auto spacingLeftStyle">
            <p className="cartHeading">{t("Play_Your_Part")}</p>
            <div>
              <span className="lightDesc">
                {t("Play_Your_Part_Description")}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12 btnMobileView">
            <Link to="/search">
              <button class="btn-custom btn-light mb-5">
                {t("Search_And_Rent")}
              </button>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
